import React from 'react';
import { observer } from 'mobx-react';

// Components
import Loader from './Common/Loader';
import Dialog from './Common/Dialog';
import Toaster from './Common/Toaster';

// Store
import store from '../stores/';

class AppLoggedOut extends React.Component {
  componentDidMount() {
    // Check browser support
    store.SessionStore.checkBrowser();
  }

  render() {
    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.className += ' touch';
    }

    if(document.querySelector('body').className.indexOf('logged-out') < 0) {
      document.querySelector('body').className += ' logged-out';
    }

    return (
      <div className="viewport">
        {React.cloneElement(this.props.children, this.props)}

        {store.SessionStore.browserUnsupported &&
          <div className={`toaster toaster--warning toaster--sm`}>
            <div className="wrap">
              <p>You are using an unsupported browser. We recommend that you <a href="http://outdatedbrowser.com/" target="_blank">update your browser</a> for the best experience.</p>
            </div>
          </div>
        }

        {store.SessionStore.loading &&
          <Loader store={store} />
        }

        {store.SessionStore.dialog &&
          <Dialog store={store} />
        }

        {store.SessionStore.toaster &&
          <Toaster store={store} />
        }
      </div>
    )
  }
}

export default observer(AppLoggedOut);



// WEBPACK FOOTER //
// ./src/app/components/AppLoggedOut.js